import * as React from "react";
import {
  TrackerPolicy,
  TrackerPolicyContentStatusOptions,
  TrackerPolicyContentTypeOptions
} from "@models/tracker-policy";
import {Modal, Table, Button, Divider, Avatar, Tooltip, Select} from "antd";
import {FormattedMessage, injectIntl, intlShape} from "react-intl";
import {PaginationDefaultParams} from "../custom/Paginator";
import {Icon} from 'antd';
import {PaymentGatewayOptions} from "../../models/paymentGateway";
import {getFormattedDate, getFormattedPrice} from "../../utils";
import {PurchaseStatusOptions} from '../../models/purchase';
import __i18n from "../../intl/__i18n";

type Props = {
  data: TrackerPolicy[];
  loading: boolean;
  deleteFn: (item: TrackerPolicy) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const TrackerPoliciesTable: React.FC<Props> = props => {
  const {data, loading, currentPage, onChangeStatus} = props;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "id",
      key: "id",
      align:"right",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: <FormattedMessage id="app.msisdn" defaultMessage={`msisdn`}/>,
      dataIndex: "user_identifier",
      key: "user_identifier",
      align:"right",
    },
    {
      title: __i18n("Purchase Date"),
      dataIndex: "created_at",
      key: "created_at",
      align:"center",
      render: (created_at, record) => getFormattedDate({date: created_at, showTime: false})
    },
    {
      title: <FormattedMessage id="app.payment_gateway" defaultMessage={`payment_gateway`}/>,
      dataIndex: "payment_gateway",
      key: "payment_gateway",
      align:"center",
      render: (payment_gateway, record) => PaymentGatewayOptions.find( item => item.value === payment_gateway )?.["label"]
    },
    {
      title: <FormattedMessage id="app.price" defaultMessage={`Price`}/>,
      dataIndex: "price",
      key: "price",
      align:"center",
      render: (price, record) => getFormattedPrice(price)
    },
    {
      title: <FormattedMessage id="app.effective_price" defaultMessage={`Effective Price`}/>,
      dataIndex: "effective_price",
      key: "effective_price",
      align:"center",
      render: (effective_price, record) => getFormattedPrice(effective_price)
    },
    {
      title: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
      key: 'status',
      width: 100,
      dataIndex: 'left',
      render: (status, record) => (
        <Select value={record.status} className={record.status}
                style={{width: "100%"}}
                onChange={(status) => onChangeStatus(status, record.id)}>
          {PurchaseStatusOptions.map((opt, index) => (
            <Select.Option key={`${record.id}_${index}`} value={opt.value}
                           recorddata={record}>{opt.label}</Select.Option>
          ))}
        </Select>
      )
    },
  ];
  
  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default injectIntl(TrackerPoliciesTable);
